const state = {
    data: []
}

const mutations = {
    storePushes (state, payload) {
        state.data = payload
    },
    storePush (state, payload) {
        state.data.unshift(payload)
    },
    updatePush (state, payload) {

    },
    pushChangeState (state, payload) {
        const push = state.data.find(item => item.id === payload.id)

        push.status = payload.status
    },
    deletePush (state, payload) {
        state.data = state.data.filter(item => item.id !== payload.id)
    }
}

const actions = {}

const getters = {
    getPushes: state => state.data
}

export default {
    state,
    mutations,
    actions,
    getters
}
